import React from 'react';

import RowGrid from "./RowGrid";
import Mensaje from './Mensaje';
import ListJurisdiccionSirtac from './ListJurisdiccionSirtac';

const formatCuit =(p_cuit)=>{
    if(p_cuit.length===11){
        const part1 = p_cuit.slice(0,2);
        const part2 = p_cuit.slice(2,10);
        const part3 = p_cuit.slice(10);

        return `${part1}-${part2}-${part3}`;
    }
    return p_cuit;
};

function ViewSIRTAC({data, anio, mes}) {
   
    let vMes = parseInt(mes) < 10 ? '0'+ mes : mes;
    let vCM = data.idJurisdiccionSede === '0' ? 1 : 0;
  return (
    <>  
        { data.sistema === 'sirtac' &&
            <div>
                <RowGrid
                    ancho="3"
                    text1="Régimen:"
                    text2={
                        data.idJurisdiccionSede !== "0"
                        ? "Local" 
                        
                        : "Convenio Multilateral"
                    }
                />
                <RowGrid ancho="3" text1="Sistema:" text2={data.sistema} />
                <RowGrid ancho="3" text1="CUIT:" text2={formatCuit(data.cuit)} />
                <RowGrid
                    ancho="3"
                    text1="Razón Social:"
                    text2={data.razonSocial}
                />
                <RowGrid
                    ancho="3"
                    text1="Período:"
                    text2={ anio + "/" + vMes}
                />
                <RowGrid
                    ancho="3"
                    text1="Alícuota aplicada:"
                    text2={data.alicuota + " %"}
                /> 
                <ListJurisdiccionSirtac data={data} />        
                
                <Mensaje tipo={vCM} />
                
        </div> 
        }
    </>
  )
}

export default ViewSIRTAC;